import { MeetingFormatEnum } from "@/types/MeetingFormat";

export function participantNeedsDisplayNamePrompt({
  meetingFormat,
  isStaffJoinLink,
  hasAuthTokenFromQuery,
}: {
  meetingFormat: MeetingFormatEnum;
  isStaffJoinLink: boolean;
  hasAuthTokenFromQuery: boolean;
}): boolean {
  if (isStaffJoinLink || hasAuthTokenFromQuery) return false;
  return meetingFormat === MeetingFormatEnum.LIVESTREAM;
}
